<template>
  <Dialog
    :visible="visible"
    :title="$t(`${namespace}.deleteEmployees`)"
    :isLoading="isLoading"
    @close="close()"
  >
    <div>
      <v-card-text
        class="dialog__body"
        v-html="$t(`${namespace}.deleteEmployeesMessage`).replace('[VAL]', items.length)"
      />

      <v-divider />

      <v-card-actions class="dialog__footer">
        <v-spacer />

        <a
          v-if="!isLoading"
          class="mr-4"
          @click.prevent="close()"
        >
          {{ $t(`${namespace}.cancel`) }}
        </a>

        <Button
          :loading="isLoading"
          :disabled="isLoading"
          @click="deleteSelectedEmployees"
        >
          {{ $t(`${namespace}.confirm`) }}
        </Button>
      </v-card-actions>
    </div>
  </Dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { catchError } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'MultipleDeleteDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    })
  },
  data () {
    return {
      namespace: 'Views.EmployeesPage.multipleDeleteDialog',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    close (reload = false) {
      this.$emit('close', reload)
    },

    setLoadingValue (boolean) {
      this.isLoading = boolean
    },

    async deleteSelectedEmployees () {
      this.setLoadingValue(true)

      try {
        const count = this.items.length
        const company = this.selectedCompany ? this.selectedCompany.id : null
        await this.$apiService.employee.multiDelete(company, this.items)

        this.close(true)
        this.showAlert({
          type: 'success',
          message: this.$t(`${this.namespace}.success`).replace('[VAL]', count)
        })
      } catch (error) {
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.error`)
        })

        catchError(error)
      }

      this.setLoadingValue(false)
    }
  }
}
</script>
